import React, { Component } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row } from 'reactstrap';

class DTCComplete extends Component {
  render() {
    return (
      <div className="page-preapproved narrow">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} className="text-center mb-2 mt-2 mt-md-4">
              <img src="/icons/pre-approved.svg" alt="Pro-Approved" className="mb-3" />
              <h1 className="mb-2">That’s it. You’re all set!</h1>
              <p className="mb-4">We just emailed you all the details about your LendingUSA loan, along with a copy of your signed loan agreement.</p>
              <Row>
                <Col sm={{size: 8, offset: 2}} md={{size: 8, offset: 2}}>
                  <h4 className="mb-4 text-primary">Please contact your merchant<br /> with any questions:</h4>
                  <Card className="dark-shadow">
                    <CardBody>
                      <h4>Petland (Kennesaw)</h4>
                      <p className="mb-0">1234 Merchant St.<br />
                      Kennessaw, GA 12345<br />
                      (555) 456-7890</p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default DTCComplete;
